import { Address } from "./Address";

export class ProductGpsr {

  constructor(
    public manufacturerName?: string,
    public address?: Address,
    public countryCode?: string,
    public website?: string,
    public contactPerson?: string,
    public supportTel?: string,
    public supportMail?: string,
    public supportWebsite ?: string,
    public warrantyPages?: string,
  ) {
    this.address = new Address();
  }
}
